<template>
    <div class="content">
        <div class="nav-view">
            <span @click="home">首页</span>
            <span class="nav-line">/</span>
            <span @click="home">新闻动态</span>
            <span class="nav-line">/</span>
            <span v-if="type == 1">集团新闻</span>
            <span v-else-if="type == 2">园区公告</span>
            <span v-else="type == 3">商务合作</span>
            <span class="nav-line">/</span>
            <span style="color: #B18148;">新闻详情</span>
        </div>
        <div class="tilte-view">{{ info.title }}</div>
        <div class="time-view">{{ info.createAt }}</div>
        <div class="lines" style="margin-top: 32px;"></div>
        <div class="html-view" v-html="info.content"></div>
        <div class="lines" style="margin-bottom: 32px;"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pageLoading: true,
            page: 1,
            total: 0,
            pageList: [],
            idx: 1,
            type: 1,
            ids: '',
            info: {}
        };
    },
    created() {
    },
    mounted() {

        this.ids = this.$route.params.id;
        this.type = this.$route.params.type;
        // const query = this.$route.query;
        // this.page = +query.page || 1;
        // this.getRecruitApi();
        this.getNewsDetailApi();
        window.scrollTo(0, 0);
    },
    methods: {
        home() {
            this.$router.push({ name: 'news' });
        },
        // 详情  
        async getNewsDetailApi() {
            try {
                const res = await this.$get('/api/other/newsDetail', {
                    newsId: this.ids
                });
                this.info = res.data;
                console.warn(res, this.pageList, "详情")
            } catch (error) {
                console.error('Error fetching basic config:', error);
            }
            this.pageLoading = false;
        },


        // 新闻动态  
        async getRecruitApi() {
            try {
                const res = await this.$get('/api/other/news', {
                    page: this.page,
                    type: this.idx
                });
                this.pageList = (res.data.data || []).map(item => {
                    return { ...item }
                });
                this.total = res.data.total || 0;
                console.warn(res, this.pageList, "新闻动态")
            } catch (error) {
                console.error('Error fetching basic config:', error);
            }
            this.pageLoading = false;
        },
        /** 分页改变 */
        pageChange() {
            this.$router.replace(`/virtuous?page=${this.page}`);
            this.getRecruitApi();
        },
        cutChange(index) {
            this.idx = index;
            this.getRecruitApi();
        },
        JumpDetails(id) {
            console.warn(id, "++++++++++id+++++++++++")
        }
    },
};  
</script>


<style lang="scss" scoped>
.content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tilte-view {
        width: 1200px;
        margin-top: 40px;
        font-size: 36px;
        font-family: PingFang SC, PingFang SC-600;
        font-weight: 600;
        color: #222222;
    }

    .time-view {
        margin-top: 16px;
        width: 1200px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #999999;
    }

    .html-view {
        width: 1200px;
        margin: 32px 0;
        line-height: 25px;
        letter-spacing: 4px;
    }

    .lines {
        width: 1200px;
        height: 1px;
        background: #e8e8e8;
    }

    .nav-view {
        width: 1200px;
        margin-top: 40px;
        display: flex;
        align-items: center;

        span {
            cursor: pointer;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            color: #666666;
        }

        .nav-line {
            margin: 0 12px;
        }
    }

    .pagination-view {
        margin-bottom: 100px;
    }

    .cut-view {
        width: 1400px;
        display: flex;
        align-items: center;

        .cut-item {
            cursor: pointer;
            margin-top: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 46px;
            border: 1px solid #222222;
            border-radius: 12px 0px 12px 0px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-500;
            font-weight: 500;
            color: #222222;
            margin-right: 20px;
        }

        .cut-item1 {
            cursor: pointer;
            margin-top: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 46px;
            border: 1px solid #B18148;
            border-radius: 12px 0px 12px 0px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-500;
            font-weight: 500;
            color: #B18148;
            margin-right: 20px;
        }
    }

    .list-page {
        margin-bottom: 48px;
        margin-top: 48px;
        width: 1400px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .list-item {
            margin-bottom: 48px;
            width: 440px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid #f1f1f1;

            .list-img {
                width: 440px;
                height: 293px;
            }

            .name {
                line-height: 25px;
                width: 376px;
                margin-top: 20px;
                font-size: 20px;
                font-family: Microsoft YaHei, Microsoft YaHei-700;
                font-weight: 700;
                color: #222222;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                /*控制在3行*/
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .time {
                margin-top: 32px;
                width: 376px;
                font-size: 14px;
                font-family: Montserrat, Montserrat-400;
                font-weight: 400;
                color: #999999;
            }

            .line {
                margin-top: 20px;
                width: 376px;
                height: 1px;
                background: #f8f6f6;
            }

            .list-more {
                margin-top: 20px;
                margin-bottom: 20px;
                width: 376px;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .list-name {
                    font-size: 14px;
                    font-family: Microsoft YaHei, Microsoft YaHei-400;
                    font-weight: 400;
                    color: #999999;
                }

                .list-detail {
                    width: 16px;
                    height: 16px;
                }
            }
        }
    }

    .content-bgc {
        width: 100%;
        height: 700px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .content-img {
            height: 100%;
            width: 100%;
        }

        .content-txt {
            display: inline-block;
            /* 防止内容撑破容器 */
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            /* 相对于自身宽高的50%进行移动，实现居中 */
            width: 1400px;

            .content-e {
                font-size: 28px;
                font-family: Montserrat, Montserrat-700;
                font-weight: 700;
                text-align: LEFT;
                color: #ffffff;
            }

            .content-c {
                margin-top: 10px;
                font-size: 54px;
                font-family: Microsoft YaHei, Microsoft YaHei-700;
                font-weight: 700;
                text-align: LEFT;
                color: #ffffff;
            }
        }
    }
}

.cur {
    cursor: pointer;
}
</style>
